module.exports = __webpack_public_path__ + "img/minvody-logotype.c0cd597b.svg";